import { InputAdornment, Tooltip } from '@mui/material';
import { Iconify } from '../iconify';

type OwnProps = {
  error: string | undefined;
};

const ErrorAdornment = ({ error }: OwnProps) => {
  return (
    <InputAdornment position="end">
      <Tooltip title={error}>
        <Iconify
          width={18}
          icon="ic:outline-error"
          style={{ fontSize: 22, cursor: 'pointer', color: '#D9331D' }}
        />
      </Tooltip>
    </InputAdornment>
  );
};

export default ErrorAdornment;
